<template>
  <section v-if="errorMessage == null">
    <BannerTitle
      :title="updateformattedTitle"
      :loading="
        LOADING &&
          ((selectedLanguage == 'es' && !translations) || !selectedLanguage)
      "
    />

    <v-col
      v-if="
        CURRENT_EVENT_OBJECT.eventLanguage === 'bi' &&
          !CURRENT_EVENT_OBJECT.legalPdfUrl
      "
      xs="12"
      sm="12"
      md="12"
      class="language-buttons"
    >
      <v-radio-group v-model="selectedLanguage" row>
        <v-radio
          ref="englishLang"
          label="English"
          value="en"
        />
        <v-radio
          ref="spanishLang"
          label="Español"
          value="es"
        />
      </v-radio-group>
    </v-col>

    <template v-if="CURRENT_EVENT_OBJECT.legalPdfUrl">
      <embed
        :title="CURRENT_EVENT_OBJECT.sweepstakesTitle + ' Official Rules'"
        class="embedded-rules"
        :src="
          CURRENT_EVENT_OBJECT.legalPdfUrl + '#toolbar=0&navpanes=0&scrollbar=0'
        "
        type="application/pdf"
      />
    </template>
    <template v-else>
      <v-container v-if="errorMessage" class="my-4">
        <p><strong>{{ errorMessage }}</strong></p>
      </v-container>

      <v-container v-if="!errorMessage" class="my-4">
        <p><strong>{{ $t('rules.no_purchase_necessary') }}</strong></p>

        <p>{{ $t('rules.by_participating') }}</p>

        <ol>
          <li>
            <strong>{{ $t('rules.timing.title') }}:</strong>
            <span v-html="$t('rules.timing.description', {
              endDate: CURRENT_EVENT_OBJECT.endDate,
              endTime: CURRENT_EVENT_OBJECT.endTime,
              startDate: CURRENT_EVENT_OBJECT.startDate,
              startTime: CURRENT_EVENT_OBJECT.startTime,
              sweepstakesTitle: CURRENT_EVENT_OBJECT.sweepstakesTitle,
              timeZone: $t('rules.timezone.' + CURRENT_EVENT_OBJECT.timezone),
            })" />

            <PastelTable
              v-if="CURRENT_EVENT_OBJECT.intervals.length > 1"
              class="my-4"
              :rows="CURRENT_EVENT_OBJECT.intervals"
              :columns="[
                {
                  source: 'startDate',
                  label: $t('rules.start_date'),
                },
                {
                  source: 'startTime',
                  label: $t('rules.start_time'),
                },
                {
                  source: 'endDate',
                  label: $t('rules.end_date'),
                },
                {
                  source: 'endTime',
                  label: $t('rules.end_time'),
                },
              ]"
            />
          </li>
          <li>
            <strong>{{ $t('rules.eligibility.title') }}:</strong>
            <span v-html="$t('rules.eligibility.description', { states: formattedEligibleStates })" />
          </li>
          <li>
            <strong>{{ $t('rules.entry.title') }}:</strong>
            {{ $t('rules.entry.begin_description') }}
            <span v-html="$t('rules.entry.' + entryLocationContent.type, {
              url: entryLocationContent.url,
              address: entryLocationContent.address,
              city: entryLocationContent.city,
              state: entryLocationContent.state,
              zip: entryLocationContent.zip
            })" />
            <span v-html="$t('rules.entry.end_description')" />
          </li>
          <li>
            <strong>{{ $t('rules.additional_terms.title') }}:</strong>
            {{ $t('rules.additional_terms.description') }}
          </li>
          <li>
            <strong>{{ $t('rules.winner_selection.title') }}:</strong>
            {{ $t('rules.winner_selection.begin_description', { numberOfWinners: CURRENT_EVENT_OBJECT.numberOfWinners }) }}
            <PastelTable
              v-if="(CURRENT_EVENT_OBJECT.winnerSelectionDate && CURRENT_EVENT_OBJECT.winnerSelectionTime) || CURRENT_EVENT_OBJECT.intervals.length"
              class="my-4"
              :rows="[
                {
                  endDate: CURRENT_EVENT_OBJECT.endDate,
                  endTime: CURRENT_EVENT_OBJECT.endTime,
                  startDate: CURRENT_EVENT_OBJECT.startDate,
                  startTime: CURRENT_EVENT_OBJECT.startTime,
                  winnerSelectionDate: CURRENT_EVENT_OBJECT.winnerSelectionDate || CURRENT_EVENT_OBJECT.intervals[CURRENT_EVENT_OBJECT.intervals.length - 1].winnerSelectionDate,
                  winnerSelectionTime: CURRENT_EVENT_OBJECT.winnerSelectionTime || CURRENT_EVENT_OBJECT.intervals[CURRENT_EVENT_OBJECT.intervals.length - 1].winnerSelectionTime,
                }
              ]"
              :columns="[
                {
                  source: 'startDate',
                  label: $t('rules.start_date'),
                },
                {
                  source: 'startTime',
                  label: $t('rules.start_time'),
                },
                {
                  source: 'endDate',
                  label: $t('rules.end_date'),
                },
                {
                  source: 'endTime',
                  label: $t('rules.end_time'),
                },
                {
                  source: 'winnerSelectionDate',
                  label: $t('rules.drawing_date'),
                },
                {
                  source: 'winnerSelectionTime',
                  label: $t('rules.drawing_time'),
                }
              ]"
            />
            <span v-html="$t('rules.winner_selection.end_description')" />
          </li>
          <li>
            <strong>{{ $t('rules.prizes.title') }}:</strong>
            {{ $t('rules.prizes.begin_description') }}
            <p v-html="formattedPrizeDescription" />
            {{ $t('rules.prizes.end_description', { arv: CURRENT_EVENT_OBJECT.arv }) }}
          </li>
          <li>
            <strong>{{ $t('rules.additional_prize_terms.title') }}:</strong>
            {{ $t('rules.additional_prize_terms.description') }}
          </li>
          <li>
            <strong>{{ $t('rules.claiming_prize.title') }}:</strong>
            {{ $t('rules.claiming_prize.description') }}
          </li>
          <li>
            <strong>{{ $t('rules.limitations.title') }}:</strong>
            {{ $t('rules.limitations.description') }}
          </li>
          <li>
            <strong>{{ $t('rules.agreement.title') }}:</strong>
            <span v-html="$t('rules.agreement.description')" />
          </li>
          <li>
            <strong>{{ $t('rules.governing_law.title') }}:</strong>
            {{ $t('rules.governing_law.description') }}
          </li>
          <li>
            <strong>{{ $t('rules.winners_list.title') }}: </strong>
            {{ $t('rules.winners_list.description') }}
          </li>
          <li>
            <strong>{{ $t('rules.privacy_policy.title') }}: </strong>
            <span v-html="$t('rules.privacy_policy.description')" />
          </li>
          <li>
            <strong>{{ $t('rules.sponsor.title') }}:</strong>
            {{ $t('rules.sponsor.description') }}
          </li>
          <li>
            {{ $t('rules.exchange.description') }}
          </li>
        </ol>
      </v-container>
    </template>
  </section>

  <section v-else>
    <BannerTitle :title="errorMessage" />
  </section>
</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex';
import OptionData from '@/utility/OptionData';
import ThemeSwitcher from '@/utility/ThemeSwitcher';
import BannerTitle from '@/components/BannerTitle.vue';
import PastelTable from '@/components/PastelTable.vue';

export default {
  name: 'GeneratedRules',
  components: {
    BannerTitle,
    PastelTable
  },
  computed: {
    ...mapGetters({
      userAttributes: `account/USER_ATTRIBUTES`,
      translations: 'translations'
    }),
    ...mapState('EVENT_MANAGER_STORE', [
      'CURRENT_EVENT_OBJECT',
      'LOADING',
      'API_CALL_IN_PROGRESS'
    ]),
    brandWatcher() {
      return this.CURRENT_EVENT_OBJECT && this.CURRENT_EVENT_OBJECT.brand
        ? this.CURRENT_EVENT_OBJECT.brand
        : 'T-Mobile';
    },
    entryLocationContent() {
      const location = this.CURRENT_EVENT_OBJECT.eventLocation

      if (location === 'Online/Virtual Event') {
        return {
          type: 'online',
          url: this.host + '/#/engagements/register/' + this.CURRENT_EVENT_OBJECT.id
        }
      }

      if (location === 'Physical/In Person Event') {
        return {
          type: 'physical',
          address: this.CURRENT_EVENT_OBJECT.physicalEventAddress,
          city: this.CURRENT_EVENT_OBJECT.physicalEventCity,
          state: this.CURRENT_EVENT_OBJECT.state,
          zip: this.CURRENT_EVENT_OBJECT.physicalEventZip
        }
      }

      if (location === 'Combination Online/In Person') {
        return {
          type: 'combination',
          url: this.host + '/#/engagements/register/' + this.CURRENT_EVENT_OBJECT.id,
          address: this.CURRENT_EVENT_OBJECT.physicalEventAddress,
          city: this.CURRENT_EVENT_OBJECT.physicalEventCity,
          state: this.CURRENT_EVENT_OBJECT.state,
          zip: this.CURRENT_EVENT_OBJECT.physicalEventZip
        }
      }

      return { type: '' };
    },
    formattedEligibleStates() {
      const states = this.CURRENT_EVENT_OBJECT.eligibleStates

      // All states or none specified
      if (!states || states.length === 0 || states.length >= 52) {
        return this.$t('rules.eligibility.all_states')
      }

      // Single state
      if (states.length === 1) {
        return states[0]
      }

      // Two states
      if (states.length === 2) {
        return `${states[0]} and ${states[1]}`
      }

      // Multiple states: "State1, State2, State3, and State4"
      return states.slice(0, -1).join(', ') + ' and ' + states[states.length - 1]
    },
    updateformattedTitle() {
      let title = this.CURRENT_EVENT_OBJECT.name + ' Official Rules';
      if (this.selectedLanguage == 'es') {
        if (this.translations.sweepstakesTitle) {
          title = this.translations.sweepstakesTitle + ' Reglamento Oficial';
        } else if (this.translations.event_name) {
          title = this.translation.event_name + ' Reglamento Oficial';
        } else {
          if (this.CURRENT_EVENT_OBJECT.sweepstakesTitle) {
            title =
              this.CURRENT_EVENT_OBJECT.sweepstakesTitle +
              ' Reglamento Oficial';
          } else {
            title = this.CURRENT_EVENT_OBJECT.name + ' Reglamento Oficial';
          }
        }
      } else if (this.selectedLanguage == 'en') {
        if (this.CURRENT_EVENT_OBJECT.sweepstakesTitle) {
          title =
            this.CURRENT_EVENT_OBJECT.sweepstakesTitle + ' Official Rules';
        }
      }
      return title;
    },
    selectedLanguage: {
      get() {
        return this.CURRENT_EVENT_OBJECT?.defaultLanguage || 'en';
      },
      set(value) {
        this.$i18n.locale = value;
        // set on event object for footer language
        this.CURRENT_EVENT_OBJECT.defaultLanguage = value;
      }
    }
  },
  methods: {
    ...mapActions(['fetchTranslations']),
    changeTheme(brand) {
      ThemeSwitcher.ChangeTheme(this, brand);
    }
  },
  data() {
    return {
      errorMessage: null,
      formattedTimezone: null,
      host: null,
      formattedPrizeDescription: null,
      formattedSpanishPrizeDescription: null,
      spanishSweepstakes: null
    };
  },
  watch: {
    brandWatcher: {
      immediate: true,
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.changeTheme(newVal);
        }
      }
    }
  },
  async created() {
    this.host = window.origin;
    let eventId = this.$route.params.id;

    if (this.userAttributes != null) {
      var loggedInResponse = await this.$store.dispatch(
        'EVENT_MANAGER_STORE/LOAD_EVENT',
        eventId
      );
      if (!loggedInResponse.id) {
        this.errorMessage =
          loggedInResponse.errorMessage || loggedInResponse.message;
        return;
      }
    } else {
      var publicResponse = await this.$store.dispatch(
        'EVENT_MANAGER_STORE/LOAD_PUBLIC_EVENT',
        eventId
      );
      if (!publicResponse.id) {
        this.errorMessage =
          publicResponse.errorMessage || publicResponse.message;
        return;
      }
      // rules should not be publicly available if archived
      if (this.CURRENT_EVENT_OBJECT.archived) {
        this.errorMessage = 'This event has been archived.';
        return;
      }
    }

    if (this.CURRENT_EVENT_OBJECT.eventLanguage === 'bi') {
      await this.fetchTranslations(this.$route.params.id);

      this.selectedLanguage = this.CURRENT_EVENT_OBJECT.defaultLanguage;
    } else {
      this.selectedLanguage = 'en';
    }

    this.formattedTimezone =
      OptionData.humanReadableTimeZoneFromValue(
        this.CURRENT_EVENT_OBJECT.timezone
      ) + ' Time';

    // generated rules are only for enter to win events
    if (this.CURRENT_EVENT_OBJECT.contestType !== 'Enter for a Chance to Win') {
      this.$router.push('/dashboard');
    }
    this.formattedTimezone =
      OptionData.humanReadableTimeZoneFromValue(
        this.CURRENT_EVENT_OBJECT.timezone
      ) + ' Time';

    if (this.translations.sweepstakesTitle) {
      this.spanishSweepstakes = this.translations.sweepstakesTitle;
    } else if (this.CURRENT_EVENT_OBJECT.sweepstakesTitle) {
      this.spanishSweepstakes = this.CURRENT_EVENT_OBJECT.sweepstakesTitle;
    } else {
      this.spanishSweepstakes = this.CURRENT_EVENT_OBJECT.name;
    }

    if (this.translations.fullPrizeDescription) {
      this.formattedSpanishPrizeDescription = this.translations.fullPrizeDescription
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;')
        .replace(/\n/g, '<br />')
        .trim();
    } else if (this.CURRENT_EVENT_OBJECT.fullPrizeDescription) {
      this.formattedSpanishPrizeDescription = this.CURRENT_EVENT_OBJECT.fullPrizeDescription
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;')
        .replace(/\n/g, '<br />')
        .trim();
    } else {
      this.formattedSpanishPrizeDescription = 'No premio';
    }
    if (this.CURRENT_EVENT_OBJECT.fullPrizeDescription) {
      this.formattedPrizeDescription = this.CURRENT_EVENT_OBJECT.fullPrizeDescription
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;')
        .replace(/\n/g, '<br />')
        .trim();
    } else {
      this.formattedPrizeDescription = 'No Prize.';
    }
  },
  updated() {
    // log the event before the user makes changes to state
    if (this.originalEvent && this.CURRENT_EVENT_OBJECT) {
      if (
        Object.keys(this.originalEvent).length === 0 &&
        this.CURRENT_EVENT_OBJECT.engagements !== undefined
      ) {
        this.originalEvent = JSON.stringify(this.CURRENT_EVENT_OBJECT);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.embedded-rules {
  width: 100%;
  height: 100vh;
}

#sidebarContainer {
  display: none;
}

.language-buttons ::v-deep .v-input--radio-group__input {
  justify-content: center;
}

.language-buttons
::v-deep
.v-input--radio-group.v-input--radio-group--row
.v-radio {
  border: 1px solid;
  color: var(--v-primary-base);
  padding: 0 30px;
  border: 1px solid var(--v-primary-base);

  .v-input--selection-controls__input {
    display: none;
  }
  label {
    color: var(--v-primary-base);
  }

  &.v-item--active {
    background: var(--v-primary-base);

    label {
      color: white;
    }
  }
}
</style>
